import React from 'react';

const services = [
  {
    icon: 'fas fa-ruler-combined',
    title: 'Études de Faisabilité & Diagnostics',
    items: [
      'Faisabilité technique pour extensions, surélévations ou ouvertures de murs porteurs.',
      'Diagnostics de structures existantes et audits de solidité.',
    ],
  },
  {
    icon: 'fas fa-calculator',
    title: 'Dimensionnement & Calculs de Structure',
    items: [
      'Note de calculs réglementaires (Eurocodes).',
      'Optimisation des sections et des ratios de matériaux (économie de matière).',
    ],
  },
  {
    icon: 'fas fa-drafting-compass',
    title: "Plans d'Exécution (EXE)",
    items: [
      'Plans de coffrage et de ferraillage (Béton Armé).',
      'Plans de traçage et d\'assemblage (Charpente Métallique).',
    ],
  },
  {
    icon: 'fas fa-clipboard-check',
    title: 'Avis Techniques & Expertises',
    items: [
      'Validation réglementaire de solutions techniques spécifiques.',
      'Assistance technique et conformité des ouvrages.',
    ],
  },
  {
    icon: 'fas fa-cubes',
    title: 'Modélisation & Ingénierie BIM',
    items: [
      'Conception sur maquette numérique 3D.',
      'Synthèse technique et détection des clashs avant chantier.',
    ],
  },
];

function ServicesSection() {
  return (
    <section className="section" style={{ padding: '100px 0', flex: 1 }}>
      <div className="section-title">
        <h2 style={{ color: '#fff' }}>Nos Prestations Spécialisées Gros Œuvre</h2>
        <div className="title-bar"></div>
        <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.8)' }}>
          Une gamme complète de services pour tous vos projets de construction
        </p>
      </div>
      <div className="container">
        <div className="card-grid">
          {services.map((s, i) => (
            <div className="card" key={i}>
              <div className="card-body">
                <div className="card-icon"><i className={s.icon}></i></div>
                <h3>{s.title}</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {s.items.map((item, j) => (
                    <li key={j} style={{ color: 'var(--text-light)', fontSize: 14, lineHeight: 1.7, marginBottom: 6, paddingLeft: 16, position: 'relative' }}>
                      <span style={{ position: 'absolute', left: 0, color: 'var(--primary)' }}>•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
